import { useParams, useNavigate } from 'react-router-dom';
import SalesMap from './SalesMap';

function SalesMapPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <SalesMap
            projectId={id}
            onClose={() => navigate('/gci/projects/list')}
        />
    );
}

export default SalesMapPage;
